import { render, staticRenderFns } from "./AllBookTopics.vue?vue&type=template&id=2b67c08d&scoped=true"
import script from "./AllBookTopics.vue?vue&type=script&lang=js"
export * from "./AllBookTopics.vue?vue&type=script&lang=js"
import style0 from "./AllBookTopics.vue?vue&type=style&index=0&id=2b67c08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67c08d",
  null
  
)

export default component.exports